import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { destinations } from '../../data/destinations';
import { SectionTitle } from '../SectionTitle';
export function Destinations() {
  return <section className="paper-texture border-b-[3px] border-noir py-16 md:py-24" data-id="element-130" data-mp="gwilxye3joxl">
      <div className="mx-auto max-w-7xl px-4 md:px-8" data-id="element-131" data-mp="l0q9hs8tiyu8">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-132" data-mp="pyrsyea5p068">
          <SectionTitle kicker="Bon voyage gustatif" title={<>
                Six destinations
                <br data-id="element-134" data-mp="zo1mlykneqwg" />
                au menu cette saison
              </>} intro="Chaque tourte est une escale. La carte tourne au fil des saisons et des envies de l’équipe." data-id="element-133" data-mp="pyi5oyghx748" />
          <Link to="/carte" className="inline-flex items-center gap-2 border-b-[3px] border-noir pb-1 font-display text-sm uppercase tracking-wide transition-colors duration-150 ease-out hover:text-rouge" data-id="element-135" data-mp="18q14et3hlz0g">
            Voir toute la carte
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-136" data-mp="2g0205e7tboyk" />
          </Link>
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-137" data-mp="2b0xtovc9w5bx">
          {destinations.map((destination, index) => <li key={destination.country} className={`flex items-center gap-4 border-[3px] border-noir px-5 py-4 transition-transform duration-150 ease-out hover:-translate-y-1 ${index % 3 === 1 ? 'bg-jaune' : 'bg-white'}`} data-id="element-138" data-mp="262nxqiiq50p9" data-mpi={index}>
              <span aria-hidden="true" className="text-3xl leading-none" data-id="element-139" data-mp="2tz1n8hfofvsm">
                {destination.flag}
              </span>
              <div className="min-w-0" data-id="element-140" data-mp="2p075litg4da3">
                <p className="font-display text-xl uppercase leading-none" data-id="element-141" data-mp="3mg4c82spnjtq">{destination.country}</p>
                <p className="mt-1 truncate text-sm font-semibold text-noir/80" data-id="element-142" data-mp="3hpnwgc1f3m47">{destination.dish}</p>
                <p className="text-xs uppercase tracking-[0.1em] text-noir/55" data-id="element-143" data-mp="1fs3xu98emr8u">{destination.note}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}